/**
 * Hospitality workflow inquiries from techforcerobotics.com/hospitality-robotics,
 * posted to /api/public/hospitality-inquiries with the same API key as the other
 * website forms.
 */

import { API_BASE } from '../config/apiBase';
import type { CampaignAttribution } from './campaignAttribution';

export interface HospitalityInquiry extends CampaignAttribution {
  id: number;
  first_name: string;
  last_name: string;
  company: string;
  email: string;
  phone: string;
  workflows: string[];
  sms_marketing_consent: boolean;
  status: string;
  created_at: string | null;
}

export async function fetchHospitalityInquiries(userId: number): Promise<HospitalityInquiry[]> {
  const res = await fetch(
    `${API_BASE}/api/marketing/hospitality-inquiries?userId=${encodeURIComponent(userId)}`
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error((data as { error?: string }).error || 'Failed to load hospitality inquiries');
  }
  return (data as { inquiries?: HospitalityInquiry[] }).inquiries ?? [];
}
